"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVariantActive = void 0;
const enums_1 = require("../enums");
const VARIANT_ENABLED_CATEGORIES = new Set([enums_1.TicketingFormCategory.Shop]);
const isVariantActive = (formCategory) => {
    return VARIANT_ENABLED_CATEGORIES.has(formCategory);
};
exports.isVariantActive = isVariantActive;
